import axios from "axios";

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SingleCoin } from "../config/Api";
import { CryptoState } from "../ContextApi";
import CoinChart from "./CoinChart";
import Header from "./Header";
import SideBar from "./SideBar";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import CoinHeader from "./CoinHeader";
const CoinPage = () => {
  const { id } = useParams();
  const [coin, setCoin] = useState();
  const [loading, setLoading] = useState(false);

  const { currency, symbol } = CryptoState();

  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));

  const fetchCoin = async () => {
    setLoading(true);
    const { data } = await axios.get(SingleCoin(id));

    setCoin(data);
    setLoading(false);
  };

  useEffect(() => {
    fetchCoin();
  }, []);

  return (
    <>
      <CoinHeader coin={coin} />
     
        <div style={{ display: "flex",flexDirection:`${isMatch?"column":"row"}`,
      
      }}>
          {loading ? (
            <h4>loading</h4>
          ) : (
            <><div style={{width:"100%"}}>
              <CoinChart coin={coin} />
              </div>
              <div
          style={{
           
            display: "flex",
            justifyContent:`${isMatch?"start":"center"}`,
            width:`${isMatch?"100%":"50%"}`,
            marginTop: 25,
            // borderLeft: "2px solid",
            
          }}
        >
              <SideBar coin={coin} />
              </div>
            </>
          )}
        </div>
        
          {/* {loading ? <h4>loading</h4> : <SideBar coin={coin} />} */}
        
      
    </>
  );
};

export default CoinPage;
